import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Mail, MailCheck } from "lucide-react";
import { useAuth } from "../lib/auth";
import Brand from "../components/Brand";

export default function ForgotPassword() {
  const { forgotPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setMsg(""); setBusy(true);
    const r = await forgotPassword(email.trim());
    setBusy(false);
    if (r.ok) {
      setSent(true);
      setMsg(r.message || "If that email matches an account, a reset link has been sent.");
    } else {
      setErr(r.error || "Could not send reset email.");
    }
  };

  return (
    <div className="pf-blueprint-bg" style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
      <div className="pf-card pf-grain" style={{ width: 440, padding: 32 }}>
        <Link to="/" className="pf-heading" style={{ display: "inline-flex", alignItems: "center", color: "var(--pf-text)", textDecoration: "none", marginBottom: 22 }}>
          <Brand height={84} withTagline testId="forgot-brand" />
        </Link>

        {sent ? (
          <div data-testid="forgot-sent">
            <div style={{ display: "inline-flex", width: 56, height: 56, background: "var(--pf-surface-2)", border: "1px solid var(--pf-border)", alignItems: "center", justifyContent: "center", borderRadius: 2, marginBottom: 18 }}>
              <MailCheck size={24} color="var(--pf-spark)" />
            </div>
            <h1 className="pf-heading" style={{ fontSize: 26, margin: "0 0 10px" }}>Check your inbox</h1>
            <p style={{ color: "var(--pf-text-muted)", fontSize: 14, lineHeight: 1.55, margin: "0 0 18px" }}>
              {msg} The link expires in 60 minutes.
            </p>
            <Link to="/login" className="btn btn-primary" data-testid="forgot-back-to-login">
              Back to sign in <ArrowRight size={13} />
            </Link>
          </div>
        ) : (
          <>
            <div className="pf-overline" style={{ marginBottom: 6 }}>ACCESS · RECOVERY</div>
            <h1 className="pf-heading" style={{ fontSize: 28, margin: "0 0 10px" }}>Reset your password</h1>
            <p style={{ color: "var(--pf-text-muted)", fontSize: 13.5, lineHeight: 1.55, margin: "0 0 20px" }}>
              Enter the email associated with your Capexara Process Industry account. We'll send a single-use link to set a new password.
            </p>

            <form onSubmit={submit}>
              <label className="pf-label" htmlFor="fp-email">EMAIL</label>
              <input
                id="fp-email" className="pf-input" type="email" autoComplete="email" required
                value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="you@company.com" data-testid="forgot-email"
              />

              {err && (
                <div className="pf-sev pf-sev-error" style={{ display: "block", marginTop: 14, padding: "8px 10px" }} data-testid="forgot-error">
                  {err}
                </div>
              )}

              <button type="submit" className="btn btn-primary" style={{ marginTop: 20, width: "100%" }} disabled={busy || !email.trim()} data-testid="forgot-submit">
                {busy ? <><span className="pf-spin" /> Sending…</> : <><Mail size={14} /> Send reset link <ArrowRight size={14} /></>}
              </button>
            </form>

            <div style={{ marginTop: 18, fontSize: 13, color: "var(--pf-text-muted)" }}>
              Remembered it? <Link to="/login" className="pf-link" data-testid="forgot-to-login">Back to sign in</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
